<template>
  <div  id="contact" class="contact">
    <div class="about-content">
        <h2 ><span >ABOUT US</span></h2>
        <SLine></SLine>
        <div style="margin-top:50px;">
          <p>Wejoyo is a fast growing independent developer and publisher of mobile games. We are a creative and innovative game company dedicated to delivering unique and entertaining experiences. With a focus on originality and fun, we strive to create games that captivate and excite players worldwide.​
           We are looking for passionate people to help us create compelling games.</p>
          <p>If you want to be part of a fast-paced, creative and fun environment, send your resume to us. We'd really love to hear from you.</p>
        </div>
    </div>
    <!-- <img style="object-position:50% 50%;width:288px;height:234px;object-fit:cover" alt="" src="../assets/earth.gif"> -->
    <div class="contact-content">
        <h2 ><span >Contact US</span></h2>
        <SLine></SLine>
        <div style="margin-top:50px;">
          <p>&nbsp; &nbsp;Email:&nbsp; &nbsp;<a href="mailto:bd@wejoyo.com">bd@wejoyo.com</a></p>
          <p>&nbsp; &nbsp;Address:&nbsp;&nbsp;北京市昌平区龙域北街8号院1号楼16层1603</p>
        </div>
    </div>
  </div>
</template>
<script>
import SLine from './Item_center_line'
export default {
  components:{
    SLine,
  }
}
</script>
<style>
  .contact-content{
    background-color: #eee;
    padding: 80px;
    width: 70%;
    margin: 0 auto;
    font-size: 15px;
  }
  .contact{
    background: url("../assets/bg_ct.png") no-repeat;
    background-size: cover;
    background-position: center center;
    color: #222;
    padding: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue